<template>
  <div class="team-picker" :class="{ filled: !!modelValue }">

    <label class="picker-label">{{ label }}</label>

    <!-- تیم انتخاب‌شده -->
    <div v-if="selected" class="selected-team">
      <img v-if="selected.logo" :src="selected.logo" :alt="displayName(selected)" class="sel-logo"/>
      <span v-else class="sel-logo fallback">{{ (displayName(selected) || '؟').slice(0, 2) }}</span>
      <div class="sel-meta">
        <strong>{{ displayName(selected) }}</strong>
        <small v-if="selected.matchCount != null && selected.matchCount > 0">{{ faNum(selected.matchCount) }} بازی ثبت‌شده</small>
        <small v-else-if="selected.area && selected.area.name">{{ selected.area.name }}</small>
      </div>
      <button type="button" class="clear-btn" title="حذف انتخاب" @click="$emit('input', null)">×</button>
    </div>

    <!-- جستجو -->
    <div v-else class="search-wrap">
      <input
          type="text"
          class="search-input"
          :placeholder="placeholder"
          v-model="query"
          @input="onInput"
          @focus="open = results.length > 0"
          @blur="closeSoon"
      />
      <i v-if="loading" class="fas fa-spinner fa-spin search-icon"></i>
      <i v-else class="fas fa-search search-icon"></i>

      <ul v-if="open && results.length" class="results">
        <li
            v-for="t in results"
            :key="t.id"
            class="result-row"
            @mousedown.prevent="pick(t)"
        >
          <img v-if="t.logo" :src="t.logo" :alt="displayName(t)" class="r-logo"/>
          <span v-else class="r-logo fallback">{{ (displayName(t) || '؟').slice(0, 2) }}</span>
          <span class="r-name">{{ displayName(t) }}</span>
          <small v-if="t.matchCount != null && t.matchCount > 0" class="r-area">{{ faNum(t.matchCount) }} بازی</small>
          <small v-else-if="t.area && t.area.name" class="r-area">{{ t.area.name }}</small>
        </li>
      </ul>

      <div v-else-if="open && tried && !loading && !results.length" class="results empty">
        تیمی پیدا نشد
      </div>
    </div>

  </div>
</template>

<script>
import apiService from '@/services/api'

export default {
  name: 'TeamPicker',

  props: {
    label: { type: String, default: 'انتخاب تیم' },
    placeholder: { type: String, default: 'نام تیم را بنویسید...' },
    // تیم انتخاب‌شده: { id, name, slug, logo, area } یا null
    value: { type: Object, default: null },
    // برای غیرفعال‌کردن انتخاب مجدد همان تیم در سمت مقابل
    excludeId: { type: Number, default: null },
  },

  data() {
    return {
      query: '',
      results: [],
      loading: false,
      tried: false,
      open: false,
      timer: null,
    }
  },

  computed: {
    modelValue() { return this.value; },
    selected() { return this.value; },
  },

  methods: {
    // نام نمایشی: نام فارسی استاندارد از بک‌اند (faName) در اولویت
    displayName(t) {
      if (!t) return '';
      return t.faName || t.name || '';
    },

    faNum(n) {
      if (n === null || n === undefined || n === '') return '';
      return String(n).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    },

    onInput() {
      clearTimeout(this.timer);
      const q = this.query.trim();
      if (q.length < 2) { this.results = []; this.open = false; this.tried = false; return; }
      this.timer = setTimeout(() => this.search(q), 300);
    },

    async search(q) {
      this.loading = true;
      this.tried = true;
      try {
        const rows = await apiService.searchTeams(q, 8);
        this.results = (rows || []).filter(t => t.id !== this.excludeId);
        this.open = true;
      } catch (e) {
        this.results = [];
      } finally {
        this.loading = false;
      }
    },

    pick(team) {
      this.open = false;
      this.query = '';
      this.results = [];
      this.$emit('input', team);
    },

    closeSoon() {
      setTimeout(() => { this.open = false; }, 150);
    },
  },
}
</script>

<style scoped lang="scss">
.team-picker {
  flex: 1;
  min-width: 0;
}

.picker-label {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 8px;
}

/* تیم انتخاب‌شده */
.selected-team {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 2px solid #3b82f6;
  border-radius: 14px;
  padding: 12px 14px;
}

.sel-logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
  flex-shrink: 0;

  &.fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e0e7ff;
    color: #1e40af;
    font-weight: 800;
    border-radius: 50%;
    font-size: 14px;
  }
}

.sel-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;

  strong { font-size: 15px; color: #111827; }
  small { color: #6b7280; font-size: 12px; }
}

.clear-btn {
  margin-right: auto;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: background .2s;

  &:hover { background: #fee2e2; color: #dc2626; }
}

/* جستجو */
.search-wrap {
  position: relative;
}

.search-input {
  width: 100%;
  height: 52px;
  border: 2px dashed #cbd5e1;
  border-radius: 14px;
  background: #fff;
  padding: 0 42px 0 14px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color .2s;

  &:focus { border-color: #3b82f6; border-style: solid; }
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  color: #94a3b8;
}

.results {
  position: absolute;
  z-index: 30;
  top: calc(100% + 6px);
  right: 0;
  left: 0;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, .15);
  max-height: 280px;
  overflow-y: auto;

  &.empty {
    padding: 14px;
    text-align: center;
    color: #94a3b8;
    font-size: 13px;
  }
}

.result-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: background .15s;

  &:hover { background: #eff6ff; }
}

.r-logo {
  width: 30px;
  height: 30px;
  object-fit: contain;
  flex-shrink: 0;

  &.fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e0e7ff;
    color: #1e40af;
    font-weight: 700;
    border-radius: 50%;
    font-size: 11px;
  }
}

.r-name {
  font-size: 14px;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.r-area {
  margin-right: auto;
  color: #94a3b8;
  font-size: 12px;
  flex-shrink: 0;
}
</style>
